var map = {
	"./1_x1.png": 16985,
	"./1_x2.png": 2978,
	"./1_x4.png": 90996,
	"./1_x7.png": 13455,
	"./2_x2.png": 20603,
	"./2_x4.png": 45389,
	"./2_x6.png": 67423,
	"./2_x8.png": 52401,
	"./3_x12.png": 35645,
	"./3_x3.png": 6829,
	"./3_x6.png": 38464,
	"./3_x9.png": 39559,
	"./4_x12.png": 49030,
	"./4_x16.png": 25986,
	"./4_x4.png": 82699,
	"./4_x8.png": 7479,
	"./normal_multiplier_1.png": 95251,
	"./normal_multiplier_2.png": 49496,
	"./normal_multiplier_4.png": 52910,
	"./normal_multiplier_7.png": 6917,
	"./symbol_0.png": 30409,
	"./symbol_1.png": 59232,
	"./symbol_10.png": 12514,
	"./symbol_11.png": 33643,
	"./symbol_12.png": 80144,
	"./symbol_13.png": 60697,
	"./symbol_14.png": 83974,
	"./symbol_15.png": 6639,
	"./symbol_16.png": 87732,
	"./symbol_17.png": 8861,
	"./symbol_2.png": 37563,
	"./symbol_3.png": 39698,
	"./symbol_4.png": 95853,
	"./symbol_5.png": 55908,
	"./symbol_6.png": 10559,
	"./symbol_7.png": 14230,
	"./symbol_8.png": 42513,
	"./symbol_9.png": 28296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54751;